"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PluginBase = void 0;

var PluginBase = function PluginBase(a, b, c) {
  _classCallCheck(this, PluginBase);

  this.driver = a, this.plugin = b, this.stream = c;
};

exports.PluginBase = PluginBase;